/**
 * FastAPI Backend Configuration
 * dist2 构建时 __FASTAPI_BASE_URL__ 为空，与后端同源使用相对路径
 */
export const FASTAPI_CONFIG = {
  // FastAPI Backend URL（dist2 为空，使用相对路径）
  BASE_URL: __FASTAPI_BASE_URL__,

  // API Endpoints
  ENDPOINTS: {
    // Authentication
    AUTH: {
      LOGIN: '/api/v1/auth/login',
      REGISTER: '/api/v1/auth/register',
      LOGOUT: '/api/v1/auth/logout',
      ME: '/api/v1/auth/me',
      CHANGE_PASSWORD: '/api/v1/auth/change-password'
    },

    // User Management
    USERS: {
      LIST: '/api/v1/users/',
      GET: '/api/v1/users/{id}',
      UPDATE: '/api/v1/users/{id}',
      DELETE: '/api/v1/users/{id}',
      TOGGLE_ACTIVE: '/api/v1/users/{id}/toggle-active',
      TOGGLE_ADMIN: '/api/v1/users/{id}/toggle-admin'
    },

    // ComfyUI Proxy
    COMFYUI: {
      API: '/api/v1/comfyui',
      INTERNAL: '/api/v1/comfyui/internal',
      EXTENSIONS: '/api/v1/comfyui/extensions',
      DOCS: '/api/v1/comfyui/docs',
      TEMPLATES: '/api/v1/comfyui/templates',
      WORKFLOW_TEMPLATES: '/api/v1/comfyui/workflow_templates'
    },

    // Workflow Management
    WORKFLOW: {
      API: '/api/v1/workflow'
    },

    // Share Management
    SHARES: {
      API: '/api/v1/shares'
    },

    // Tags Management
    TAGS: {
      API: '/api/v1/tags'
    },

    // Tutorials
    TUTORIALS: {
      API: '/api/v1/tutorials'
    },

    // Progress Management
    PROGRESS: {
      API: '/api/v1/progress'
    },

    // Files Management
    FILES: {
      API: '/api/v1/files'
    },

    // Upload Management
    UPLOAD: {
      API: '/api/v1/upload'
    },

    // Chat Management
    CHAT: {
      API: '/api/chat',
      MODELS: '/api/chat/models',
      CONVERSATIONS: '/api/chat/conversations',
      COMPLETIONS: '/api/chat/completions'
    },

    // WebSocket
    WEBSOCKET: '/ws'
  }
}

/**
 * Get full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  return `${FASTAPI_CONFIG.BASE_URL}${endpoint}`
}

/**
 * Get ComfyUI proxy URL
 */
export const getComfyUIUrl = (endpoint: string): string => {
  return `${FASTAPI_CONFIG.BASE_URL}${endpoint}`
}

/**
 * Get WebSocket URL
 */
export const getWebSocketUrl = (token?: string): string => {
  const base =
    FASTAPI_CONFIG.BASE_URL ||
    (typeof window !== 'undefined'
      ? `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`
      : '')
  const baseUrl = base.replace('http://', 'ws://').replace('https://', 'wss://')
  const endpoint = FASTAPI_CONFIG.ENDPOINTS.WEBSOCKET
  return token
    ? `${baseUrl}${endpoint}?token=${token}`
    : `${baseUrl}${endpoint}`
}
